import { render, staticRenderFns } from "./createOrderFixed.vue?vue&type=template&id=9be0220c&scoped=true"
import script from "./createOrderFixed.vue?vue&type=script&lang=js"
export * from "./createOrderFixed.vue?vue&type=script&lang=js"
import style0 from "./createOrderFixed.vue?vue&type=style&index=0&id=9be0220c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be0220c",
  null
  
)

export default component.exports